import { selectEnv } from 'common-nextjs';

const bigCatUserId = selectEnv(407715, 224496);

export default bigCatUserId;
